import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoFilled, Link } from "@air/next-icons";
import { Tooltip } from "@air/primitive-tooltip";
import { LINK_NOT_AVAILABLE, NO_SHARE_LINK } from "~/constants/testIDs";
export const NoPermissionToCreateShareLink = ()=>/*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        className: "size-4 text-grey-9"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "pl-2 text-16 text-grey-9",
                        "data-testid": NO_SHARE_LINK,
                        children: "No shareable link"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mr-3",
                "data-testid": LINK_NOT_AVAILABLE,
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    label: "You do not have permissions to create this link. Contact your workspace admin for help.",
                    children: /*#__PURE__*/ _jsx(InfoFilled, {
                        className: "size-5 text-grey-9"
                    })
                })
            })
        ]
    });
